import { api, apiBytes } from "./client";
import type { DateFormat, Lang, NumberFormat } from "../i18n";

/* Languages and number/date formats (server/locale.js). */

type Options = { languages: Record<string, string>; number_formats: Record<string, string>; date_formats: Record<string, string> };

/** A staff member's own choice (null = the organisation's) and what is in effect. */
export type MyLocale = Options & {
  language: Lang;
  number_format: NumberFormat;
  date_format: DateFormat;
  chosen: { language: Lang | null; number_format: NumberFormat | null; date_format: DateFormat | null };
};
export type OrgLocale = Options & { language: Lang; number_format: NumberFormat; date_format: DateFormat };
export type CustomerLocale = { language: Lang | null; effective: Lang; languages: Record<string, string> };

export const locale = {
  me: () => api<MyLocale>("GET", "/admin/locale/me"),
  saveMe: (b: Partial<Record<"language" | "number_format" | "date_format", string | null>>) => api<MyLocale>("PUT", "/admin/locale/me", b),
  org: () => api<OrgLocale>("GET", "/admin/locale/org"),
  saveOrg: (b: Partial<Record<"language" | "number_format" | "date_format", string>>) => api<OrgLocale>("PUT", "/admin/locale/org", b),
  customer: (id: string) => api<CustomerLocale>("GET", `/admin/locale/customers/${encodeURIComponent(id)}`),
  saveCustomer: (id: string, language: string | null) => api<CustomerLocale>("PUT", `/admin/locale/customers/${encodeURIComponent(id)}`, { language }),
  overrides: (lang: Lang) => api<{ language: Lang; texts: Record<string, string> }>("GET", `/admin/locale/overrides/${lang}`),
  /* Translations for native review (server/lang-strings.js): counts, the CSV of a language, and a corrected CSV back. */
  strings: () => api<{ languages: LangStrings[]; statuses: string[] }>("GET", "/admin/locale/strings"),
  stringsCsv: (lang: Lang) => apiBytes("GET", `/admin/locale/strings/${lang}`).then((r) => r.blob()),
  importStrings: (lang: Lang, file: Blob) => apiBytes("POST", `/admin/locale/strings/${lang}`, file, { "Content-Type": "text/csv" }).then((r) => r.json() as Promise<LangImport>),
};

export type LangStrings = { code: Lang; name: string; total: number; translated: number; reviewed: number; corrected: number; needs_review: number };
export type LangImport = LangStrings & { imported: number; marked_reviewed: number; reset: number; unchanged: number; rejected: { line: number; english: string; reason: string }[] };
